
export default function department( state = [], action = {} ){

	switch( action.type ){
		case 'SAVE_DEPARTMENT':
			return action.department
		case 'GET_DEPARTMENT':
			return action.department
		case 'DELETE_DEPARTMENT':
			return action.department
		case 'GET_BY_ID_DEPARTMENT':
			return action.department
		case 'EDIT_DEPARTMENT':
			return action.department
		default: return state;
	}
		
}




// WEBPACK FOOTER //
// ./src/store/reducers/department/department.reducer.js